import { graphql } from "@cappelendamm/crystallize-types/pim/gql";
export const getAllApps = async ({ tenantId }, { client }) => {
    const data = await client.pim.request(graphql(`
      query GetAllApps($tenantId: ID!) {
        app {
          getMany(filter: { tenantId: $tenantId }) {
            edges {
              node {
                tenantId
                identifier
                name
              }
            }
          }
        }
      }
    `), { tenantId });
    return data.app.getMany.edges?.map((edge) => {
        return edge.node;
    });
};
